module.exports = new __parcel__URL__("pvp_heavy_attack_button_disabled.bacd5d7d.png").toString();